import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type {
  Finanziamento,
  CreateFinanziamentoInput,
  UpdateFinanziamentoInput,
} from '../types';

export function useCreateFinanziamento() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateFinanziamentoInput) =>
      api.post<Finanziamento>('/finanziamenti', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useUpdateFinanziamento() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: {
      id: string;
      projectId: string;
      data: UpdateFinanziamentoInput;
    }) => api.patch<Finanziamento>(`/finanziamenti/${variables.id}`, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useDeleteFinanziamento() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string; projectId: string }) =>
      api.delete(`/finanziamenti/${id}`),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
